module.exports = __webpack_public_path__ + "static/media/ordinary-day.99bb9390.png";